export const isIdGenerated = (id: string) => id.startsWith('new-')

export const generateId = () => `new-${crypto.randomUUID()}`
